import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AccessDialogComponent } from './access-dialog.component';
import { MaterialModule } from 'src/app/material.module';
import { SharedModule } from 'src/app/shared/shared.module';

@NgModule({
  imports: [
    CommonModule,
    MaterialModule,
    SharedModule
  ],
  declarations: [
    AccessDialogComponent 
  ],
  exports: [
    AccessDialogComponent
  ],
  entryComponents: [
    AccessDialogComponent
  ]
})
export class AccessDialogModule { }
